import { render, staticRenderFns } from "./EmailSupplierButton.vue?vue&type=template&id=351876d4"
import script from "./EmailSupplierButton.vue?vue&type=script&lang=js"
export * from "./EmailSupplierButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports